<template>
  <v-form v-model="formValid" ref="form" autocomplete="off">
    <v-container class="pa-0">
      <h1 class="wizard-header-text"
          style="display: flex">
        <span v-if="!isMobile"> {{ title }} </span>
        <div class="wizard-header-info">
          <span>Cenu poistenia vypočítame na základe vami zadaných údajov</span>
        </div>
      </h1>
      <debug-control
        @click="log"
        v-if="debug"
        :value="[
          'validationObjectResult',
          'formValid',
          'somethingGetDirty',
          'currentControl',
          'somethingIsLoading',
        ]"
        :parent="this"
      />

      <!-- <v-dialog
        v-model="warningMessage.open"
        overlay-color="#000"
        overlay-opacity="0.66"
        persistent
        eager
        max-width="500"
      >
        <v-card>
          <v-card-title class="d-flex justify-space-between">
            <span class="gs100 f16">Upozornenie</span>
            <v-btn icon @click="warningMessage.open = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="f16 white100" style="white-space: pre-line">
            {{ warningMessage.text }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn-secondary" @click="warningMessage.open = false"> Nie </v-btn>
            <v-btn class="btn-primary" @click="warningMessage.action()"> Áno </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->

      <v-row v-for="(item, index) in predmety" :key="index" class="card predmet-form" :class="{ 'mt-24px' : !isMobile }" no-gutters>
        <v-col cols="12">
          <v-row no-gutters :style="isMobile ? { marginBottom: '10px' } : null">
            <v-col cols="8">
              <template v-if="predmety.length > 1">
  
                <h2>{{item.typ_predmetu_sufix }}</h2>
              </template>
              <template v-else>
                <h2>{{ item.predmet ? item.predmet : 'Údaje o predmete' }}</h2>
              </template>
            </v-col>
            <v-col cols="4">
              <v-btn
                v-show="predmety.length > 1"
                @click="selectPredmet(item)"
                :disabled="item.active"
                class="pa-0 predmet-expand btn-secondary right"
              >
                <v-icon :class="{ 'rotate-180': item.active }">mdi-chevron-down</v-icon>
              </v-btn>
              <v-btn
                v-show="dbPredmety.length > 1 || (predmety.length > 1 && item.loadedFromDb == false)"
                @click="deletePredmet(item)"
                class="pa-0 mr-2 predmet-expand btn-secondary right"
              >
                <v-icon>$trash</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-expand-transition>
            <predmet-form
              :isMobile="isMobile"
              :ref="'predmetForm' + item.cislo_predmetu"
              :cisloPredmetu="item.cislo_predmetu"
              :newId="pripad.newId"
              :reloaded="item.active"
              :key="'predmetForm' + item.cislo_predmetu"
              :active="item.active"
              @vinChecking="() => setValid(false, 'checkVin', '', false, false)"
              @vinChecked="() => setValid(true, 'checkVin', '', false, false)"
              @resetCheckPredmet="() => setValid(true, 'checkPredmet', '', false, false)"
              @changeSufixPredmetu="(val) => item.typ_predmetu_sufix = val"
            />
        </v-expand-transition>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import DynamicCombo from '../basic/DynamicCombo';
import PredmetForm from '../predmet/PredmetForm';
import TextGroup from '../basic/TextGroup';
import { wizardMixin } from '../../mixins/wizardMixin.js';
import protectedAxios from '../../auth/axios';
import { mapMutations, mapState, mapGetters } from 'vuex';
import { eventBus } from '../../main.js';

export default {
  mixins: [wizardMixin],
  components: {
    DynamicCombo,
    PredmetForm,
    TextGroup,
  },
  data: () => ({
    defaultMessage: {
      text: 'Polia označené hviezdičkou sú povinné.',
      isError: false,
    },
    predmety: [], //TODO: sem sa budu nacitavat uz pridane predmety
    show: true,
    predmetFormKey: 0,
    warningMessage: {
      open: false,
      text: '',
      shown: false,
      action: () => {},
    },
  }),
  computed: {
    ...mapGetters(['debug','isMobile']),
    newPredmetExists() {
      return (
        this.predmety.filter(p => p.loadedFromDb === false).length > 0 || this.pripad.jeRozpracovany
      );
    },
    dbPredmety(){
      return this.predmety.filter(p => p.loadedFromDb === true)
    }
  },
  methods: {
    ...mapMutations(['setCisloPredmetu', 'setPredmetZamknuty', 'openDialog', 'closeDialog']),
    reload() {
      let cisloPredmetu = this.pripad.cisloPredmetu;
      protectedAxios
        .get(`pripady/${this.pripad.newId}/predmety`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          res.data.forEach(function (element, index) {
            if (element.cislo_predmetu === cisloPredmetu) {
              element.active = true;
            } else {
              element.active = false;
            }
            element.loadedFromDb = true;
          });
          if (res.data.length === 0 || res.data.filter(p => p.active === true).length === 0) {
            this.addPredmetToArray(res.data);
          }
          this.predmety = res.data;
        })
        .catch(e => {
          console.error(e);
        });
    },
    refreshModelyVerzie(cisloPredmetu) {
      const refName = 'predmetForm' + (cisloPredmetu ?? this.pripad.cisloPredmetu);
      const ref = this.$refs[refName];
      const form = Array.isArray(ref) ? ref[0] : ref;
      form?.refreshModelyVerzieFromParent?.();
    },
    async selectPredmet(item) {
      this.$emit('predmetSelected');
      return await this.removePredmetFromCache()
        .then(() =>
          protectedAxios.get(
            `/pripady/${this.pripad.newId}/predmety/${
              item.cislo_predmetu
            }/load-cache`
          )
        )
        .then(async () => {
          if (!item.active) {
            this.predmety.forEach(function (element, index) {
              element.active = false;
            });
            const predmetZamknuty = await protectedAxios
              .get(
                `/pripady/${this.pripad.newId}/predmety/${
                  item.cislo_predmetu
                }/je-zamknuty`
              )
              .then(res => !!res.data);
            this.setCisloPredmetu(item.cislo_predmetu);
            this.setPredmetZamknuty(predmetZamknuty);
            item.active = true;
            this.predmety = this.predmety.filter(p => p.loadedFromDb != false);
          }
        });
    },
    async addPredmetToArray(predmetArray, duplicate) {
      predmetArray.forEach(function (element, index) {
        element.active = false;
      });
      let cisloPredmetu = 1;
      if (predmetArray.length > 0) {
        cisloPredmetu = Math.max(...predmetArray.map(o => o.cislo_predmetu), 1);
        cisloPredmetu++;
      }
      let newPredmet = {
        cislo_predmetu: cisloPredmetu,
        predmet: '',
        active: true,
        loadedFromDb: false,
        typ_predmetu_sufix: '',
      };

      const predmetZamknuty = await protectedAxios
        .get(
          `/pripady/${this.pripad.newId}/predmety/${cisloPredmetu}/je-zamknuty`
        )
        .then(res => !!res.data);

      this.setCisloPredmetu(cisloPredmetu);
      this.setPredmetZamknuty(predmetZamknuty);

      let prom = Promise.resolve();
      if (duplicate) {
        prom = protectedAxios.post(
          `/pripady/${this.pripad.newId}/predmety/update-cislo-predmetu?cisloPredmetu=${cisloPredmetu}`
        );
      }

      prom
        .then(() => {
          predmetArray.push(newPredmet);
          this.emitDirty(true);
        })
        .catch(e => console.log(e));
    },
    addPredmetClick() {
      this.removePredmetFromCache().then(() => {
        this.addPredmetToArray(this.predmety);
      });
    },
    removePredmetFromCache() {
      return protectedAxios
        .delete(
          `/pripady/${this.pripad.newId}/predmety/${this.pripad.cisloPredmetu}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {})
        .catch(e => {
          console.error(e);
        });
    },
    deletePredmet(item) {
      let _dialog = {
        persistent: true,
        header: `<span class="gs100 f16">Odstrániť predmet</span>`,
        closeIcon: {
          value: true,
        },
        text: `<span class="f16">Naozaj si prajete odstrániť predmet?</span>`,
        primaryBtn: {
          text: `Odstrániť`,
          func: null,
        },
      };
      return new Promise((res, rej) => {
        _dialog.primaryBtn.func = () => {
          this.confirmDeletePredmet(item);
          this.closeDialog();
          res(true);
        };
        this.openDialog(_dialog);
      });
    },
    async confirmDeletePredmet(item) {
      let nextPredmet = 0;
      for(let index in this.predmety){
        if(this.predmety[index].cislo_predmetu != item.cislo_predmetu){
          nextPredmet = this.predmety[index];
          break;
        }
      }
      await this.selectPredmet(nextPredmet)
        .then(async () => { 
                await protectedAxios
                    .post(`/pripady/${this.pripad.newId}/predmety/${item.cislo_predmetu}/zmazat`, {
                      headers: {
                        'Content-Type': 'application/json',
                      },
                    })
                    .then(res => {
                      if(res.data.error){
                        eventBus.$emit('snack-error', 'Pri mazaní predmetu nastala chyba: ' + res.data.errorText);
                      }else{
                        this.reload()            
                      }
                    })
                    .catch(e => {
                      console.error(e);
                    });
                
              });
    },
    //beforeStep vola PripadyWizard.vue po validacii formulara. Musi vratit promise !!!
    async beforeStep() {
      const predmetMsg = await protectedAxios
          .get(
            `/pripady/check-predmet`
          )
          .then(res => res.data)
          .catch(e => (
            console.error(e)
          ));
      if(predmetMsg){
        this.setValid(false, 'checkPredmet', predmetMsg, false, true);
        return Promise.resolve(false);
      }else{
        this.setValid(true, 'checkPredmet', '', false, false);
      }
      const ocRef = `predmetForm${this.pripad.cisloPredmetu}`;
      if(!this.$refs[ocRef][0].jeTechnologia){
        const vinMsg = await protectedAxios
          .get(
            `/pripady/${this.pripad.newId}/predmety/${
              this.pripad.cisloPredmetu
            }/check-vin`
          )
          .then(res => res.data);

        if (vinMsg) {
          this.setValid(false, 'checkVin', vinMsg, false, true);
          return Promise.resolve(false);
        }
      }

      
      return await this.$refs[ocRef][0].beforeStep().then(res => {
        if(!res){
          return Promise.resolve(false);
        }
        this.clearDirty();
        return protectedAxios
          .get(
            `/pripady/${this.pripad.newId}/predmety/${
              this.pripad.cisloPredmetu
            }/kontrola-cennikovej-ceny`
          )
          .then(res => {
            // this.warningMessage.shown = res.data.show;
            // if (this.warningMessage.shown) {
            //   this.warningMessage.text = res.data.text;
            //   this.warningMessage.open = true;
            //   return new Promise((res, rej) => {
            //     this.warningMessage.action = () => {
            //       this.warningMessage.open = false;
            //       res(true);
            //     };
            //   });
            // }
            if (res.data.show) {
              let _dialog = {
                persistent: true,
                header: `<span class="gs100 f16">Upozornenie</span>`,
                closeIcon: {
                  value: true,
                  func: null
                },
                text: `<span class="f16 white100">${res.data.text} </span>`,
                primaryBtn: {
                  text: `Pokračovať`,
                  func: null,
                },
                secondaryBtn: {
                  text: `Späť`,
                  func: null,
                },
              };
              return new Promise((res, rej) => {
                _dialog.primaryBtn.func = () => {
                  this.closeDialog();
                  res(true);
                };
                _dialog.secondaryBtn.func = () => {
                  this.closeDialog();
                  res(false);
                };
                _dialog.closeIcon.func = () => {
                  this.closeDialog();
                  res(false);
                };

                
                this.openDialog(_dialog);
              });
            }
            return true;
          })
          .catch(e => {
            console.log(e);
            return Promise.resolve(false);
          });
      });
    },
  },
  watch: {
    currentControl(val) {
      if (val === this.controlName) {
        if (this.$route.query.duplikovat_predmet) {
          this.$router.replace({ query: null });
          this.addPredmetToArray(this.predmety, true);
        }
      }
    },
  },
};
</script>
<style lang="sass">
.predmet-form

  .predmet-expand
    min-width: 38px !important
  .v-expansion-panel-content__wrap
    padding: 0
  .v-expansion-panel--active
    min-height: auto
</style>
